// src/dashboard/reducers/dashboards.js
import {
  FETCH_DASHBOARDS_REQUEST,
  FETCH_DASHBOARDS_SUCCESS,
  FETCH_DASHBOARDS_FAILURE,
} from "../actions/dashboards";

const initialState = { data: [], status: "idle", error: null, fetchedAt: 0 };

export default function dashboardsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DASHBOARDS_REQUEST:
      return { ...state, status: "loading", error: null };
    case FETCH_DASHBOARDS_SUCCESS:
      return { data: action.payload.data, status: "success", error: null, fetchedAt: Date.now() };
    case FETCH_DASHBOARDS_FAILURE:
      return { ...state, status: "error", error: action.payload.error };
    default:
      return state;
  }
}
